<template>
  <a-time-picker
    v-bind="attrs"
    :class="[bem.b(), bem.is(isGray ? 'gray-time-picker' : '')]"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-time-picker>
</template>

<script lang="ts" setup>
import { useAttrs } from 'vue'
// import { TimePicker } from 'ant-design-vue'
import { createNamespace } from '@ll-plus/utils'
import { timePickerProps } from './time-picker'
defineOptions({ name: 'LlTimePicker' })

const attrs = useAttrs()
const bem = createNamespace('time-picker')

defineProps(timePickerProps)
</script>
